import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {CustomTooltip} from "../../CalendarPercent/styles";
import {useHistory} from "react-router-dom"

const Day = React.memo(({day, inDay, selectDate, type, salesActiveClose}) => {
    const history = useHistory()
    let dataDate = new Date(day).getDate()


    let personeTitle = (persone) => {
        switch (persone) {
            case 'dop':
                return {text: '', icon: 'user-plus', title: 'Цена за доп.место'}
                break
            case 'child':
                return {text: '', icon: 'baby', title: 'Цена за детское место'}
                break
            default:
                return {text: persone, icon: 'user-friends', title: 'Количество основных мест'}
                break
        }
    }


    const notSale = history.location.pathname.split('/').includes('calendar') && salesActiveClose && salesActiveClose.includes(day)

    return (
        <div
            className={`${notSale ? 'notSale' : '' } ${inDay.selected ? 'selected' : ''} ${inDay.disabled ? 'disabled' : ''} ${new Date(day).toDateString() === new Date().toDateString() ? 'today' : ''}`}
            data-date={dataDate} data-full-date={day}
            onClick={() => !inDay.disabled && selectDate(day)}>
            {type === "busy"
                ? <div className="free-cell">
                    {inDay.count}
                </div>
                : <div className="price-cell">
                    {inDay.price && inDay.price.length !== 0 && inDay.price.map((price, index) =>
                        price.value && <div key={price.value + index} data-person-count={personeTitle(price.type).text}>

                            <CustomTooltip title={personeTitle(price.type).title} arrow placement="top">
                                <span>
                                    <FontAwesomeIcon icon={personeTitle(price.type).icon} className="mx-1"/>
                                </span>
                            </CustomTooltip>

                            {price.value}
                            ₽
                        </div>
                    )}
                </div>
            }

        </div>

    )
})


export default Day